module.exports = __webpack_public_path__ + "static/media/16_l_kuch_holst_9.9_85.46.02b552d2.png";